import React from 'react';
import './Footer.css';
import footer_logo from '../Asset/logo_big.png';
import instagram_icon from '../Asset/instagram_icon.png';
import pinterest_icon from '../Asset/pintester_icon.png';
import whatsapp_icon from '../Asset/whatsapp_icon.png';

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-logo">
                <img src={footer_logo} alt="" />
                <p>FashionClub</p>
            </div>
            <ul className="footer-links">
                <li>Company</li>
                <li>Products</li>
                <li>Offices</li>
                <li>About</li>
                <li>Contact</li>
            </ul>
            <div className="footer-social-icons">
                <div className="footer-icon-container">
                    <img src={instagram_icon} alt="" />
                </div>
                <div className="footer-icon-container">
                    <img src={pinterest_icon} alt="" />
                </div>
                <div className="footer-icon-container">
                    <img src={whatsapp_icon} alt="" />
                </div>
            </div>
            <div className="footer-copyright">
                <hr />
                <p>Copyright @ 2024 Right Reserve</p>
            </div>
        </div>
    );
};

export default Footer;
